var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2252 13.2091L10.4169 11.5424V7.76744C10.4169 7.4341 10.1502 7.16743 9.81687 7.16743H9.76687C9.43354 7.16743 9.16687 7.4341 9.16687 7.76744V11.7008C9.16687 11.9924 9.31687 12.2674 9.57521 12.4174L12.6169 14.2424C12.9002 14.4091 13.2669 14.3258 13.4335 14.0424C13.6085 13.7508 13.5169 13.3758 13.2252 13.2091ZM17.6502 4.67577L15.0835 2.54243C14.7335 2.25077 14.2085 2.29243 13.9085 2.65077C13.6169 3.00077 13.6669 3.52577 14.0169 3.82577L16.5752 5.9591C16.9252 6.25077 17.4502 6.2091 17.7502 5.85077C18.0502 5.50077 18.0002 4.97577 17.6502 4.67577ZM3.41687 5.9591L5.97521 3.82577C6.33354 3.52577 6.38354 3.00077 6.08354 2.65077C5.79187 2.29243 5.26687 2.25077 4.91687 2.54243L2.35021 4.67577C2.00021 4.97577 1.95021 5.50077 2.25021 5.85077C2.54188 6.2091 3.06687 6.25077 3.41687 5.9591ZM10.0002 3.8341C5.85854 3.8341 2.50021 7.19243 2.50021 11.3341C2.50021 15.4758 5.85854 18.8341 10.0002 18.8341C14.1419 18.8341 17.5002 15.4758 17.5002 11.3341C17.5002 7.19243 14.1419 3.8341 10.0002 3.8341ZM10.0002 17.1674C6.78354 17.1674 4.16687 14.5508 4.16687 11.3341C4.16687 8.11743 6.78354 5.50077 10.0002 5.50077C13.2169 5.50077 15.8335 8.11743 15.8335 11.3341C15.8335 14.5508 13.2169 17.1674 10.0002 17.1674Z",
    fill: "#344054"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.c6ddd89dfd8481085b0d8e544e7caa10.svg";
export { ForwardRef as ReactComponent };